export const URGENT_PAYMENTS_MINIMUM_PRIORITIZATION = 2500101010;
export const AT_RISK_PAYMENTS_MINIMUM_PRIORITIZATION = 2470000000;
export const NO_PRIORITIZATION_VALUE = -1;
export const PRIORITIZATION_UPDATE_RUN_FREQUENCY_IN_MINUTES = 15;
export const PRIORITIZATION_UPDATE_MAX_EXECUTION_TIME_IN_MINUTES = 5;
export const PRIORITIZATION_SCORE_AVERAGE_DIVISOR = 5;
export const AT_RISK_PRIORITIZATION_RANGES = {
  minVal: AT_RISK_PAYMENTS_MINIMUM_PRIORITIZATION,
  maxVal: URGENT_PAYMENTS_MINIMUM_PRIORITIZATION - 1
};
